import { useMutation } from "@apollo/client";
import { CREATE_DESIGNER_MATCHING_PROFILE } from "../../graphql/designer-matching-profile";

export const useCreateDesignerMatchingProfileMutation = () => {
  const [createDesignerMatchingProfile, { loading, error, data }] = useMutation(
    CREATE_DESIGNER_MATCHING_PROFILE,
    {
      refetchQueries: ['GetDesignerStepStatus'],
      awaitRefetchQueries: true,
    }
  );

  const createProfile = async (variables: {
    designerId: string;
    personalityType?: string;
    stepCompletion?: any;
    expertise?: any;
    style?: any;
    workStyle?: any;
    preferences?: any;
  }) => {
    try {
      console.log("🔄 Creating designer matching profile with:", variables);
      const result = await createDesignerMatchingProfile({
        variables
      });
      console.log("✅ Designer matching profile created:", result);
      return result.data?.createDesignerMatchingProfile;
    } catch (error) {
      console.error("❌ Error creating designer matching profile:", error);
      throw error;
    }
  };

  return {
    createProfile,
    loading,
    error,
    data
  };
};
